// bazaar — en. Part of the en i18n bundle; merged by ./index.js

export default {
  bazaarTitle: 'Bazaar',
  bazaarSubtitle: 'Browse products from all sellers in one place',
  bazaarMarketplaceWord: 'Marketplace',
  bazaarClosedDesc: 'The All Things Bazaar is currently closed. Check back soon to browse and shop from our verified sellers.',
};

